<template>
    <div>
        <div>
            <h3 style="margin-top: 8px; font-size: 18px;">Shakey's Free Item Promotion</h3>

             <a-button type="primary" @click="showForm">Add Promo</a-button>

             <!-- CREATE MODAL -->
             <a-modal
                v-model="openModal"
                title="Supercard Promo Item"
                ok-text="Create"
                :ok-button-props="{ disabled: true }"
                :cancel-button-props="{ disabled: true }"
                @ok="add"
                >
                 <form id="form-proper">
                    <!-- error msg -->
                    <base-alert v-if="errors.length" type="danger">
                        <b>You have the following error(s):</b>
                        <li v-for="error in errors" :key="error">{{ error }}</li>
                    </base-alert>
                    <!-- success msg -->
                    <base-alert v-if="successMessage != null" type="success">
                        <span class="alert-inner--text"> {{ successMessage }}</span>
                        <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>

                    <div>
                        <base-input label="Label" style="" required>
                            <a-input type="string" v-model="label"/>
                        </base-input>
                        <b-row>
                            <b-col>
                                <base-input label="Code"  style="" required>
                                    <a-input type="string" v-model="code"/>
                                </base-input>
                            </b-col>
                            <b-col>
                                <base-input label="Status"  style="" required   >
                                    <a-select
                                        v-model="status"
                                        style="width: 100%"
                                        placeholder="Select card type"
                                        optionFilterProp="children"
                                        >
                                            <a-select-option v-for="s in statusList"
                                                :key="s.id"
                                                :value="s.code">{{ s.name }}
                                            </a-select-option>
                                    </a-select>
                                </base-input>
                            </b-col>
                        </b-row>
                        <base-checkbox v-model="promo_combination_allowed" style="margin-top: 8px;">
                            Allow promo combination
                        </base-checkbox>
                        <base-checkbox v-model="is_voucher" style="margin-top: 8px; margin-bottom: 10px;">
                            Allow voucher
                        </base-checkbox>

                        <!-- SKU -->
                        <h3 class="mt-4">SKU</h3>
                        <hr class="mt-0">
                        <b-row>
                        <b-col>
                            <base-input label="Card Type"  style="" required>
                                <a-select
                                    v-model="card_type"
                                    style="width: 100%"
                                    placeholder="Select card type"
                                    optionFilterProp="children"
                                    >
                                        <a-select-option v-for="card in supercardTypes"
                                            :key="card.id"
                                            :value="card.code">{{ card.name }}
                                        </a-select-option>
                                </a-select>
                            </base-input>
                        </b-col>
                        <b-col>
                            <base-input alternative="" label="Barcode" input-classes="form-control" required>
                                <a-select
                                    v-model="selectedBarcodes"
                                    mode="multiple"
                                    style="width: 100%"
                                    placeholder="Select Product"
                                    optionFilterProp="children"
                                    >
                                        <a-select-option v-for="product in productList"
                                                :key="product.id"
                                                :value="product.barcode">{{ product.barcode }}
                                        </a-select-option>
                                </a-select>
                            </base-input>
                        </b-col>
                        </b-row>

                        <!-- conditions -->
                        <b-row> 
                            <b-col>
                                <base-input label="Minimum Amount">
                                    <a-input type="number" v-model="amount" />
                                </base-input>
                            </b-col>
                            <b-col>
                                <base-input label="Transaction Type" input-classes="form-control">
                                    <a-select
                                        v-model="trans_type"
                                        mode="multiple"
                                        style="width: 100%"
                                        placeholder="Select transaction type"
                                        optionFilterProp="children"
                                        >
                                            <a-select-option v-for="trans in transactionTypeList"
                                                :key="trans.id"
                                                :value="trans.ref_code">{{ trans.name }}
                                            </a-select-option>
                                    </a-select>
                                </base-input>
                            </b-col>
                        </b-row>
                        <button type="button" class="btn btn-sm btn-primary"   @click.prevent="addSku" > + Add SKU </button>
                    </div>

                </form>
            </a-modal>

            <!-- VIEW AND EDIT MODAL -->
            <a-modal
                v-model="viewModal"
                title="Supercard Promo Item"
                :cancel-button-props="{ disabled: true }"
                :ok-text="modalButton"
                :ok-button-props="{ disabled: true }"
                @ok="update"
                >
                <form id="form-proper">
                    <div>
                        <!-- error msg -->
                        <base-alert v-if="errors.length" type="danger">
                            <b>You have the following error(s):</b>
                            <li v-for="error in errors" :key="error">{{ error }}</li>
                        </base-alert>
                        <!-- success msg -->
                        <base-alert v-if="successMessage != null" type="success">
                            <span class="alert-inner--text"> {{ successMessage }}</span>
                            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </base-alert>

                        <base-input label="Label" style="" required >
                            <a-input type="string" v-model="label" :disabled="viewMode"/>
                        </base-input>
                        <b-row>
                            <b-col>
                                <base-input label="Code"  style="" required >
                                    <a-input type="string" v-model="code" :disabled="viewMode"/>
                                </base-input>
                            </b-col>
                            <b-col>
                                <base-input label="Status"  style="" required >
                                    <a-select
                                        v-model="status"
                                        style="width: 100%"
                                        placeholder="Select card type"
                                        optionFilterProp="children"
                                        :disabled="viewMode"
                                        >
                                            <a-select-option v-for="s in statusList"
                                                :key="s.id"
                                                :value="s.code">{{ s.name }}
                                            </a-select-option>
                                    </a-select>
                                </base-input>
                            </b-col>
                        </b-row>
                        <base-checkbox v-model="promo_combination_allowed" style="margin-top: 8px;" :disabled="viewMode">
                            Allow promo combination
                        </base-checkbox>
                        <base-checkbox v-model="is_voucher" style="margin-top: 8px; margin-bottom: 10px;" :disabled="viewMode">
                            Allow voucher
                        </base-checkbox>
                        <h3 class="mt-4">SKU</h3>
                        <hr class="mt-0">
                        <div v-for="(sku, index) in skus" :key="index" >
                            <!-- sku -->
                            <b-row>
                                <b-col>
                                    <base-input label="Card Type"  style="" >
                                        <a-select
                                            v-model="sku.CARD_TYPE"
                                            style="width: 100%"
                                            placeholder="Select card type"
                                            optionFilterProp="children"
                                            :disabled="viewMode"
                                            >
                                                <a-select-option v-for="card in supercardTypes"
                                                    :key="card.id"
                                                    :value="card.code">{{ card.name }}
                                                </a-select-option>
                                        </a-select>
                                    </base-input>
                                </b-col>
                                <b-col>
                                    <base-input alternative="" label="Product Barcode" input-classes="form-control" >
                                    
                                        <a-select
                                            v-model="sku.BARCODES"
                                            mode="multiple"
                                            style="width: 100%"
                                            placeholder="Select Product"
                                            optionFilterProp="children"
                                            :disabled="viewMode"
                                            >
                                            <a-select-option v-for="product in productList"
                                                :key="product.id"
                                                :value="product.barcode">{{ product.barcode }}
                                            </a-select-option>
                                        </a-select>
                                    </base-input>
                                </b-col>
                            </b-row>
                            <!-- conditions -->
                            <b-row> 
                                <b-col>
                                    <base-input label="Minimum Amount">
                                        <a-input type="number" v-model="sku.CONDITIONS.AMOUNT" :disabled="viewMode"/>
                                    </base-input>
                                </b-col>
                                <b-col>
                                    <base-input label="Transaction Type" input-classes="form-control" >
                                        <a-select
                                            v-model="sku.CONDITIONS.TRANS_TYPE"
                                            mode="multiple"
                                            style="width: 100%"
                                            placeholder="Select transaction type"
                                            optionFilterProp="children"
                                            :disabled="viewMode">
                                                <a-select-option v-for="trans in transactionTypeList"
                                                    :key="trans.id"
                                                    :value="trans.ref_code">{{ trans.name }}
                                                </a-select-option>
                                        </a-select>
                                    </base-input>
                                </b-col>
                            </b-row>   
                        </div>          
                        <!-- <button v-if="!viewMode" type="button" class="btn btn-sm btn-primary"   @click.prevent="updateSku" > + Add SKU </button> -->
                    </div>
                </form>
            </a-modal>
            
            <!-- TABLE -->
            <a-spin :spinning="loading">
                <div class="row">
                    <div class="col-md-6 offset-md-2">
                        <a-table 
                            :dataSource="dataSource" 
                            :columns="columns" size="small">
                            <template slot="status" slot-scope="text, record">
                                <span>{{ record.STATUS ? 'True' : 'False' }}</span>
                            </template>
                            <template slot="is_voucher" slot-scope="text, record">
                                <span>{{ record.IS_VOUCHER ? 'True' : 'False' }}</span>
                            </template>
                            <template slot="promo_combination_allowed" slot-scope="text, record">
                                <span>{{ record.PROMO_COMBINATION_ALLOWED ? 'True' : 'False' }}</span>
                            </template>
                            <template slot="action" slot-scope="text, record">
                                <button @click="viewRecord(record)" style="margin-right: 5px;" class="btn btn-success btn-sm">View</button>
                                <button @click="editRecord(record)" style="margin-right: 5px;" class="btn btn-warning btn-sm">Edit</button>
                                <a-popconfirm
                                    title="Are you sure to delete this record?"
                                    @confirm="deleteRecord(record)"
                                    @cancel="cancelDelete"
                                    okText="Yes"
                                    cancelText="No">
                                    <button type="danger" class="btn btn-danger btn-sm">Delete</button>
                                </a-popconfirm>
                            </template>
                        </a-table>
                    </div>
                    <div class="col-md-2"> 
                    </div>
                </div>
            </a-spin>
        </div>
    </div>
    
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import ValidateField from '../../components/validateFormUtils'
    // import secureStorage from '../controllers/secureStorage.js'
    import { mapState } from 'vuex'

    let component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId']),
            dataSource: function (){
                return this.menus.map( promo => {
                    return promo;
                })
            },
            modalButton: function (){
                if (this.viewMode == true){
                    return "Ok"
                } else {
                    return "Update"
                }
            }
        },
        
        mounted: async function () {
            this.loading = true;
            component_x = this;
            var account_name = secureStorage.getItem("accountName")
            this.accountName = account_name;
            // console.log(this.accountName)

            if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null){
                this.menus = this.$attrs.defaultValue
                this.isNewSetting = false
            }
            this.settingCode = this.$attrs.settingCode
            this.loading = false

            const products_data = await HTTPRequest.getRequest(this.endPoint + 'products/get_all_valid_products', null)
            this.productList = products_data;

            const trans_type_data = await HTTPRequest.getRequest(this.endPoint + 'pos_transaction_types/get_valid_pos_transaction_types', null)
            this.transactionTypeList = trans_type_data;
        },
        watch: {
            menus: {
                handler: async function(){
                    var configValues = {}
                    configValues[this.settingCode] = this.menus
                    component_x.$emit("changeValue", configValues)
                },
                deep: true
            },
            selectedBarcodes(newVal) {
                this.barcodes = newVal.map(barcode => ({ CODE: barcode }));
            }
        },
        data() {
            return {
                loading: false,
                errors: [],
                successMessage: null,
                openModal: false,
                viewModal: false,
                viewMode: false,
                transactionTypeList: [],
                tranproductListsactionTypeList: [],
                selectedPaymentTypes: [],
                currentIndex: null,
                statusList: [
                    {id: 1, code: 'A', name: 'Active'},
                    {id: 2, code: 'I', name: 'Inactive'}
                ],
                supercardTypes: [
                    {id: 1, code: 'ALL', name: 'All'},
                    {id: 2, code: 'CLASSIC', name: 'Classic'},
                    {id: 3, code: 'GOLD', name: 'Gold'},
                ],
                menus: [],
                settingCode: null,
                accountName: '',
                label: '',
                card_type: '',
                barcodes: [],
                selectedBarcodes: [],
                viewBarcodes: [],
                status: 'A',
                code: '',
                sku: [],
                conditions: {},
                trans_type: [],
                amount: null,
                promos: [],
                promo_combination_allowed: false,
                item: [],
                is_voucher: false,
                productList: [],
                columns: [
                    { title: "Label", dataIndex: "LABEL"},
                    { title: "Code", dataIndex: "CODE"},
                    { title: "Status", dataIndex: "STATUS", scopedSlots: { customRender: 'status' }},
                    { title: "Is Voucher", dataIndex: "IS_VOUCHER", scopedSlots: { customRender: 'is_voucher' } },
                    { title: "Promo Condition Allowed", dataIndex: "PROMO_COMBINATION_ALLOWED", scopedSlots: { customRender: 'promo_combination_allowed' } },
                    { title: "Action", dataIndex: "ACTION", scopedSlots: { customRender: 'action' } },
                    // { title: "Action", dataIndex: "promo_combination_allowed"},

                ],
                skus: [],
            }
        },  
        methods: {
            clearFields(){
                this.label = ''
                this.code = ''
                this.is_voucher = false
                this.promo_combination_allowed = false
                this.card_type = null
                this.barcodes = []
                this.selectedBarcodes = []
                this.amount = null
                this.trans_type = []

                // error and success alert
                this.errors = []
                this.successMessage = null
            },
            showForm(){
                this.clearFields();
                this.openModal = true
            },
            handleOk(){
                // 
            },
            removeMessage() {
                this.successMessage = null
            },
            cancelDelete() {
                this.isDeleteModalVisible = false;
                this.recordToDelete = null;
            },
            transformSku(record){
                if (Array.isArray(record.SKUS)) {
                    this.skus = record.SKUS.map(sku => ({
                        CARD_TYPE: sku.CARD_TYPE,
                        BARCODES: sku.BARCODES.map(barcode => barcode.CODE),
                        CONDITIONS: sku.CONDITIONS || {}
                    }));
                } else {
                    this.skus = [];
                }
            },
            reverseSku(){
                if (Array.isArray(this.skus)) {
                    this.skus = this.skus.map(sku => ({
                        CARD_TYPE: sku.CARD_TYPE,
                        BARCODES: sku.BARCODES.map(code => ({ CODE: code })),
                        CONDITIONS: sku.CONDITIONS
                    }));
                }
            },
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Label', this.label));
                this.errors.push(ValidateField.required('Code', this.code));
                this.errors.push(ValidateField.charMinAndMax('Label', this.label, 1, 20));
                this.errors.push(ValidateField.charMinAndMax('Code', this.code, 1, 30));

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            addSku(){
                if(this.card_type !== '' && this.barcodes.length > 0){
                    let list_of_sku = {
                        CARD_TYPE: this.card_type,
                        BARCODES: this.barcodes,
                        CONDITIONS: {
                                    AMOUNT: this.amount,
                                    TRANS_TYPE: this.trans_type
                        }
                    }
                    this.sku.push(list_of_sku)
                    this.successMessage = "SKU item addedd successfully."
                    // clear fields
                    this.card_type = null
                    this.selectedBarcodes = []
                    this.amount = null
                    this.trans_type = []
                } else {
                    this.errors.push('Card type and barcode is required.');
                }
            },
            updateSku(){

            },
            add(){
                if(!this.validateForm()){
                    if (this.label != undefined)
                        this.label = this.label.trim() 
                    if (this.code != undefined)
                        this.code = this.code.trim() 

                    // check if code already exist on list
                    const codeExists = this.menus.some(promo => promo.code === this.code);
                    if(!codeExists){
                        if(this.sku.length > 0){
                            this.menus.push(
                                {
                                    LABEL: this.label,
                                    SKUS:this.sku,
                                    PROMO_COMBINATION_ALLOWED: this.promo_combination_allowed,
                                    CODE: this.code,
                                    STATUS: this.status,
                                    IS_VOUCHER: this.is_voucher
                                }
                            )
                            
                            // clear fields
                            this.clearFields();
                            this.openModal = false
                        } else {
                            this.errors.push('Please enter at least one SKU item.');
                        }
                    } else {
                        this.errors.push('Code already exist.');
                    }
                } 
                this.dataSource
            },
            viewRecord(record) {
                this.viewMode = true;
                this.viewModal = true;
                this.successMessage = null
                this.errors = []
                // assign data on viewMode
                this.label = record.label;
                this.code = record.code;
                this.status = record.status;
                this.promo_combination_allowed = record.promo_combination_allowed;
                this.is_voucher = record.is_voucher;
                // Transform SKUs and extract barcode codes
                this.transformSku(record)

            },
            editRecord(record){
                this.viewMode = false;
                this.viewModal = true;
                this.successMessage = null
                this.errors = []
                // get record index
                this.currentIndex = this.menus.findIndex(item => item.CODE === record.CODE);
                // assign data on editMode
                this.label = record.LABEL;
                this.code = record.CODE;
                this.status = record.STATUS;
                this.promo_combination_allowed = record.PROMO_COMBINATION_ALLOWED;
                this.is_voucher = record.IS_VOUCHER;
                // Transform SKUs and extract barcode codes
                this.transformSku(record)
            },
            update(){
                if(this.viewMode == true){
                    this.viewModal = false
                } else {
                    if(!this.validateForm()){
                        if (this.label != undefined)
                        this.label = this.label.trim() 
                        if (this.code != undefined)
                            this.code = this.code.trim() 

                        if(this.skus.length > 0){
                            // remove current record first
                            this.menus.splice(this.currentIndex, 1);

                            // Transform SKUs and format barcode codes
                            this.reverseSku();
                            const cleanedData = JSON.parse(JSON.stringify(this.skus));

                            this.menus.push(
                                {
                                    LABEL: this.label,
                                    CODE: this.code,
                                    STATUS: this.status,
                                    PROMO_COMBINATION_ALLOWED: this.promo_combination_allowed,
                                    IS_VOUCHER: this.is_voucher,
                                    SKUS: cleanedData,
                                }
                            )
                            // clear fields
                            this.clearFields();
                            this.viewModal = false;
                        } else {
                            this.errors.push('Please enter at least one SKU item.');
                        }
                    }
                }
                this.dataSource
            },
            deleteRecord(record) {
                this.menus = this.menus.filter(item => item.CODE !== record.CODE);
            }
        }
    }
</script>
